import { api } from 'config/api'
import type { RubricConfigPayload } from 'pages/instructor/assignment/dialogs/customRubricsConfig'

type SaveCustomRubricsArgs = {
  sectionId: string
  assignmentId: string
  rubricConfigs: RubricConfigPayload[]
}

/**
 * Persists per-assignment custom rubric config via the AdonisJS server
 * endpoint. Throws on failure — callers surface a generic save-failed toast
 * and roll back.
 */
export async function saveCustomRubrics({
  sectionId,
  assignmentId,
  rubricConfigs,
}: SaveCustomRubricsArgs): Promise<void> {
  const result = await api.v1.assignments.rubrics.upsert({
    body: { sectionId, assignmentId, rubricConfigs },
  })

  if (!result.success) {
    throw new Error('failed to save custom rubrics')
  }
}
